import { applyTextBundle } from '../actions';
import { connectEditor } from '../connect-editor';
import { isSelectable, isSelected } from '../utils';
import TextBundlesModal from './TextBundlesModal';

const mapStateToProps = ({ campaign, campaignLinesById }) => {
  const selectedLineIds = Object.values(campaignLinesById)
    .filter(isSelectable)
    .filter(isSelected)
    .map(line => line.id);
  return {
    brand: campaign.brands[0],
    selectedLineIds,
  };
};

const mapDispatchToProps = {
  applyTextBundle,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onApplyTextBundle: selectedBundle =>
    dispatchProps.applyTextBundle(selectedBundle, stateProps.brand),
  onApplyTextBundleToSelectedLines: selectedBundle =>
    dispatchProps.applyTextBundle(
      selectedBundle,
      stateProps.brand,
      stateProps.selectedLineIds,
    ),
});

export default connectEditor(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(TextBundlesModal);
